import React, { useState, useEffect, useContext } from 'react'
import {
  CButton,
  CCard,
  CCol,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSwitch,
  CImage,
} from '@coreui/react'
import FBLogo from '../../../assets/FacebookLogo.png'
import InstaLogo from '../../../assets/InstagramLogo.png'
import TGLogo from '../../../assets/TelegramLogo.png'
import YTLogo from '../../../assets/YoutubeLogo.png'
import BitchuteLogo from '../../../assets/bitchute-logo.png'
import BoxcastLogo from '../../../assets/boxcast-icon.png'
import RumbleLogo from '../../../assets/rumble-logo.png'
import TikTokLogo from '../../../assets/tiktok-logo.png'
import TwitterLogo from '../../../assets/TwitterLogo.png'
import { updateStaticPages } from 'src/Redux/Actions/templateAction'
import { useDispatch } from 'react-redux'
import { checkPermissions } from 'src/views/utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { dispatchAlert } from 'src/Redux/Actions/authAction'

const SocialLinks = ({ data }) => {
  const dispatch = useDispatch()

  const [visibleStatus, setVisibleStatus] = useState(data.visible)
  const [socialLinks, setSocialLinks] = useState({
    facebook: '',
    twitter: '',
    instagram: '',
    telegram: '',
    youtube: '',
    bitchute: '',
    tiktok: '',
    rumble: '',
    boxcast: '',
  })

  const [socialBool, setSocialBool] = useState({
    facebook: false,
    twitter: false,
    instagram: false,
    telegram: false,
    youtube: false,
    bitchute: false,
    tiktok: false,
    rumble: false,
    boxcast: false,
  })

  const { userSessionObj } = useContext(GlobalContext)

  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.WEBSITE.UPDATE,
  )

  useEffect(() => {
    setVisibleStatus(data.visible)
  }, [data])

  useEffect(() => {
    setSocialLinks(data.content)
    checkSocialBool()
  }, [data.content])

  const checkSocialBool = () => {
    let tempBool = socialBool
    for (const key in data.content) {
      const element = data.content[key]

      element ? (tempBool[key] = true) : (tempBool[key] = false)
    }
    setSocialBool({ ...tempBool })
  }

  const handleSave = async () => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    const contentPayload = {
      facebook: socialBool.facebook ? socialLinks.facebook : '',
      twitter: socialBool.twitter ? socialLinks.twitter : '',
      instagram: socialBool.instagram ? socialLinks.instagram : '',
      telegram: socialBool.telegram ? socialLinks.telegram : '',
      youtube: socialBool.youtube ? socialLinks.youtube : '',
      bitchute: socialBool.bitchute ? socialLinks.bitchute : '',
      tiktok: socialBool.tiktok ? socialLinks.tiktok : '',
      rumble: socialBool.rumble ? socialLinks.rumble : '',
      boxcast: socialBool.boxcast ? socialLinks.boxcast : '',
    }
    const payload = {
      title: data.title,
      visible_on_website: visibleStatus,
      content: contentPayload,
    }

    const updateRes = await dispatch(updateStaticPages(payload, data.id))
    if (updateRes?.success) {
      dispatch({ type: 'REFRESH_DATA' })
      dispatch(dispatchAlert('success', `Success`, `Updated Successfully!`, true))
    }
  }

  const handleChange = (e, key) => {
    let { value } = e.target
    setSocialLinks((socialLinks) => ({
      ...socialLinks,
      [key]: value,
    }))
  }
  const handleCheck = (e, key) => {
    let { checked } = e.target
    setSocialBool((socialBool) => ({
      ...socialBool,
      [key]: checked,
    }))
  }
  return (
    <div>
      <CCard style={{ minHeight: '37rem' }}>
        <div className="mt-5 mx-5 h-100">
          <div className="d-flex justify-content-between">
            <CCol xs="6" className="">
              <p className="mx-5">Provide your Social Footprints</p>
            </CCol>
            <CCol className="d-flex justify-content-center">
              <CFormSwitch
                label={visibleStatus ? 'Enabled on your website.' : 'Disabled on your website.'}
                checked={visibleStatus}
                valid={visibleStatus}
                onChange={(e) => setVisibleStatus(e.target.checked)}
                size="lg"
              />
            </CCol>
          </div>
          <div className="mt-5 mx-5">
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.facebook}
                  valid={socialBool.facebook}
                  onChange={(e) => {
                    handleCheck(e, `facebook`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={FBLogo} className="mx-2" width={30} height={30} />
                <CFormLabel>Facebook</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.facebook}
                  onChange={(e) => handleChange(e, `facebook`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.twitter}
                  valid={socialBool.twitter}
                  onChange={(e) => {
                    handleCheck(e, `twitter`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={TwitterLogo} className="mx-2" width={30} height={30} />
                <CFormLabel>Twitter</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.twitter}
                  onChange={(e) => handleChange(e, `twitter`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.instagram}
                  valid={socialBool.instagram}
                  onChange={(e) => {
                    handleCheck(e, `instagram`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={InstaLogo} className="mx-2" width={30} height={30} />
                <CFormLabel>Instagram</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.instagram}
                  onChange={(e) => handleChange(e, `instagram`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.telegram}
                  valid={socialBool.telegram}
                  onChange={(e) => {
                    handleCheck(e, `telegram`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={TGLogo} className="mx-2" width={30} height={30} />
                <CFormLabel>Telegram</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.telegram}
                  onChange={(e) => handleChange(e, `telegram`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.youtube}
                  valid={socialBool.youtube}
                  onChange={(e) => {
                    handleCheck(e, `youtube`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={YTLogo} className="mx-2" width={30} height={30} />
                <CFormLabel>Youtube</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.youtube}
                  onChange={(e) => handleChange(e, `youtube`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.bitchute}
                  valid={socialBool.bitchute}
                  onChange={(e) => {
                    handleCheck(e, `bitchute`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={BitchuteLogo} className="mx-2" width={25} height={25} />
                <CFormLabel>Bitchute</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.bitchute}
                  onChange={(e) => handleChange(e, `bitchute`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.tiktok}
                  valid={socialBool.tiktok}
                  onChange={(e) => {
                    handleCheck(e, `tiktok`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={TikTokLogo} className="mx-2" width={30} height={30} />
                <CFormLabel>Tik Tok</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.tiktok}
                  onChange={(e) => handleChange(e, `tiktok`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.rumble}
                  valid={socialBool.rumble}
                  onChange={(e) => {
                    handleCheck(e, `rumble`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={RumbleLogo} className="mx-2" width={25} height={25} />
                <CFormLabel>Rumble</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.rumble}
                  onChange={(e) => handleChange(e, `rumble`)}
                />
              </CCol>
            </div>
            <div className="mb-4 w-75 d-flex align-items-center">
              <CCol xs="1">
                <CFormCheck
                  checked={socialBool.boxcast}
                  valid={socialBool.boxcast}
                  onChange={(e) => {
                    handleCheck(e, `boxcast`)
                  }}
                />
              </CCol>
              <CCol xs="3">
                <CImage fluid src={BoxcastLogo} className="mx-2" width={25} height={25} />
                <CFormLabel>Boxcast</CFormLabel>
              </CCol>
              <CCol xs="6">
                <CFormInput
                  size="sm"
                  className="w-100"
                  value={socialLinks.boxcast}
                  onChange={(e) => handleChange(e, `boxcast`)}
                />
              </CCol>
            </div>
          </div>
          <div className="d-flex mt-4 flex-row-reverse mb-3">
            <CButton
              color="info"
              className="text-white mx-5"
              onClick={handleSave}
              disabled={!updateAllowed}
            >
              Save
            </CButton>
          </div>
        </div>
      </CCard>
    </div>
  )
}

export default SocialLinks
